export { default as DraftModeResearchPlatformListingSection } from './DraftModeResearchPlatformListingSection.client';
export { default as ResearchPlatformListingSection } from './ResearchPlatformListingSection';
